import api from './api'

export const authService = {
  // Login with email and password
  async login(email, password) {
    const formData = new FormData()
    formData.append('username', email) // OAuth2 spec uses username field
    formData.append('password', password)

    const response = await api.post('/auth/login', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  // Register new user
  async register(email, password, fullName) {
    const response = await api.post('/auth/register', {
      email,
      password,
      full_name: fullName
    })
    return response.data
  },

  // Logout
  async logout() {
    try {
      const response = await api.post('/auth/logout')
      return response.data
    } catch (error) {
      // Continue with logout even if API call fails
      console.error('Logout API error:', error)
    }
  },

  // Get current user
  async getCurrentUser() {
    const response = await api.get('/users/me')
    return response.data
  },

  // Get user permissions
  async getUserPermissions() {
    const response = await api.get('/users/me/permissions')
    return response.data
  },

  // Update profile
  async updateProfile(data) {
    const response = await api.put('/users/profile', data)
    return response.data
  },

  // Change password
  async changePassword(currentPassword, newPassword) {
    const response = await api.post('/users/change-password', {
      current_password: currentPassword,
      new_password: newPassword
    })
    return response.data
  },

  // Request password reset
  async resetPassword(email) {
    const response = await api.post('/auth/password-reset', { email })
    return response.data
  },

  // Confirm password reset
  async confirmPasswordReset(token, newPassword) {
    const response = await api.post('/auth/password-reset/confirm', {
      token,
      new_password: newPassword
    })
    return response.data
  },

  // Verify email
  async verifyEmail(token) {
    const response = await api.post('/auth/verify-email', { token })
    return response.data
  },

  // Resend verification email
  async resendVerificationEmail() {
    const response = await api.post('/users/resend-verification')
    return response.data
  },

  // Refresh token
  async refreshToken(refreshToken) {
    const response = await api.post('/auth/refresh', {
      refresh_token: refreshToken
    })
    return response.data
  },

  // Get OAuth URL
  async getOAuthUrl(provider) {
    const redirectUri = `${window.location.origin}/auth/callback/${provider}`
    const response = await api.get(`/auth/oauth/${provider}`, {
      params: { redirect_uri: redirectUri }
    })
    return response.data.auth_url
  },

  // Handle OAuth callback
  async handleOAuthCallback(provider, code, state) {
    const response = await api.post(`/auth/oauth/${provider}`, {
      provider,
      code,
      state
    })
    return response.data
  },

  // Get login history
  async getLoginHistory(limit = 10, offset = 0) {
    const response = await api.get('/users/login-history', {
      params: { limit, offset }
    })
    return response.data
  },

  // Get user statistics (admin only)
  async getUserStats() {
    const response = await api.get('/users/stats')
    return response.data
  },

  // Delete account
  async deleteAccount(password) {
    const response = await api.delete('/users/account', {
      data: { password }
    })
    return response.data
  }
}